import React from "react";

import { getOrderHistory }
  from '../../../helpers/historyOrder'

import OrderCard
  from './OrderCard'

import NotFoundItems
  from './NotFoundItems'

import ReactLoading
  from 'react-loading';

class Total extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      totalItems: []
    };
  }

  componentDidMount() {
    getOrderHistory(this.fetchOrderHistory.bind(this), { search: this.props.search })
  }

  componentWillReceiveProps(newProps) {
    if( newProps.search !== this.props.search ||
        newProps.sort !== this.props.sort ||
        newProps.startDate !== this.props.startDate ||
        newProps.endDate !== this.props.endDate ||
        newProps.page !== this.props.page) {
      this.setState({loading: true})
      getOrderHistory(this.fetchOrderHistory.bind(this),
        {
          page: newProps.page,
          search: newProps.search,
          sort: newProps.sort,
          startDate: newProps.startDate,
          endDate: newProps.endDate
        }
      )
    }
  }

  fetchOrderHistory(data) {
    this.setState({totalItems: data, loading: false})
    this.props.addObjectItems(data)
  }

  displayOrders() {
    let { loading, totalItems } = this.state
    let { data } = totalItems
    let { translate } = this.props

    if(data.length > 0) {
      return (
        data.map((item) => {
          return (
            <OrderCard
              key={item.id}
              item={item}
            />
          )
        })
      )
    } else {
      return (
        <NotFoundItems
          icon={"order-history"}
          objectName={"orders"}
          title={translate("settings.order_history.not_found_items.total_title")}
          description={translate("settings.order_history.not_found_items.description")}
        />
      )
    }
  }

  render() {
    let { loading } = this.state
    if(loading) {
      return (
        <div style={{ height: 500, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <ReactLoading type="spin" color="#bea58b"/>
        </div>
      )
    }

    return (
      <div className="settings-history-list">
        <div className="settings-history-list-wrap">
          {this.displayOrders()}
        </div>
      </div>
    )
  }
}

export default Total;
